// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bili-banner[data-v-61c0ca5a] {
  margin: 0 auto;
  position: relative;
  z-index: 0;
  min-height: 155px;
  height: 9.375vw;
  min-width: 999px;
  background-color: #f9f9f9;
  display: flex;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: center 0;
  background-size: cover;
}
.bili-banner .taper-line[data-v-61c0ca5a] {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100px;
  background: linear-gradient(rgba(0, 0, 0, 0.4), transparent);
}
/*# sourceMappingURL=Banner.css.map */`, "",{"version":3,"sources":["webpack://./Banner.vue"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EAGA,iBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,yBAAA;EACA,aAAA;EACA,uBAAA;EAEA,4BAAA;EACA,6BAAA;EACA,sBAAA;AALF;AAZA;EAoBI,oBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,4DAAA;AALJ;AACA,qCAAqC","sourcesContent":["\n.bili-banner {\n  margin: 0 auto;\n  position: relative;\n  z-index: 0;\n  // max-width: 2560px;\n  // max-height: 240px;\n  min-height: 155px;\n  // todo 兼容性？\n  height: 9.375vw;\n  min-width: 999px;\n  //min-height: 155px;\n  background-color: #f9f9f9;\n  display: flex;\n  justify-content: center;\n\n  background-repeat: no-repeat;\n  background-position: center 0;\n  background-size: cover;\n\n  .taper-line {\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 0;\n    width: 100%;\n    height: 100px;\n    background: linear-gradient(rgba(0, 0, 0, 0.4), transparent);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
